var _circle, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFuelBackHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.4693 46.4132C50.4693 44.7238 43.5467 43.3542 35.0071 43.3542C26.4676 43.3542 19.5449 44.7238 19.5449 46.4132C19.5966 46.6926 19.6685 46.968 19.76 47.2372C20.8122 50.4133 22.8498 53.18 25.5827 55.1434C28.3155 57.107 31.6046 58.1672 34.9816 58.1732C38.3585 58.1793 41.6514 57.1309 44.3915 55.1772C47.1315 53.2236 49.1793 50.4642 50.2431 47.2919C50.3494 47.0077 50.4252 46.7132 50.4693 46.4132ZM35.0071 43.8899C44.6616 43.8899 49.9282 45.5568 49.9282 46.4132C49.9282 47.2696 44.6616 48.9366 35.0071 48.9366C25.3528 48.9366 20.0861 47.2696 20.0861 46.4132C20.0861 45.5568 25.3528 43.8899 35.0071 43.8899Z",
    fill: "url(#paint0_linear_5447_24565)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4573 34.1707C48.7395 32.6225 42.5407 31.4126 35 31.4126C27.7293 31.4126 21.7061 32.5374 20.6406 34.0058C20.1972 34.7377 19 40.0097 19 42.3371C19 42.3627 19.002 42.6318 19.002 42.7314C19.002 44.4208 26.1645 45.7904 35 45.7904C43.8355 45.7904 50.998 44.4208 50.998 42.7314C50.998 42.6317 51 42.3627 51 42.3371C51 39.9717 49.5755 34.3616 49.4573 34.1707ZM35 31.9483C44.0491 31.9483 48.9855 33.6152 48.9855 34.4716C48.9855 35.328 44.0491 36.9949 35 36.9949C25.9509 36.9949 21.0145 35.3281 21.0145 34.4716C21.0145 33.6152 25.9509 31.9483 35 31.9483Z",
    fill: "url(#paint1_linear_5447_24565)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8295 22.583C43.2761 21.6523 39.6018 20.9346 35.0136 20.9346C30.4869 20.9346 26.7529 21.6378 26.2177 22.5459C26.1743 22.6195 26.0526 22.8442 25.9782 22.9771C25.3091 24.1708 22.0273 30.1591 22.0273 30.7424C22.0273 31.9196 27.6351 32.8772 34.6272 32.9106C34.6618 32.9107 34.9672 32.9122 35.004 32.9122C42.1708 32.9122 47.9806 31.9407 47.9806 30.7423C47.9806 30.1771 44.9498 24.5376 44.1501 23.1019C44.0327 22.8909 43.8715 22.6422 43.8295 22.583ZM35.0136 21.4702C39.9398 21.4702 42.9054 22.2807 43.3114 22.7707C42.9054 23.2608 39.9398 24.0713 35.0136 24.0713C30.0874 24.0713 27.1217 23.2608 26.7158 22.7707C27.1217 22.2807 30.0874 21.4702 35.0136 21.4702Z",
    fill: "url(#paint2_linear_5447_24565)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0036 21.4831C40.4005 21.4831 42.5991 20.0746 42.5991 20.0746C38.5619 13.5717 35.0036 9 35.0036 9C35.0036 9 31.4454 13.5717 27.4082 20.0746C27.4082 20.0746 29.5005 21.4831 35.0036 21.4831Z",
    fill: "url(#paint3_linear_5447_24565)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5447_24565",
    x1: 19.5449,
    y1: 50.9214,
    x2: 49.0925,
    y2: 50.9214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED560E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89C15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5447_24565",
    x1: 19,
    y1: 38.7544,
    x2: 49.5753,
    y2: 38.7544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED560E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89C15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5447_24565",
    x1: 22.0273,
    y1: 27.0508,
    x2: 46.8252,
    y2: 27.0508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED560E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89C15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5447_24565",
    x1: 27.4082,
    y1: 15.3744,
    x2: 41.9228,
    y2: 15.3744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED560E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89C15"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFuelBackHome);
export default __webpack_public_path__ + "static/media/icon-fuel-back-home.17bed0229a965e9bedf97842f6035371.svg";
export { ForwardRef as ReactComponent };